import React, { useState } from 'react';
import { useLocation } from 'react-router';
import Paper from '@mui/material/Paper';
import Emails from './tabs/Emails';
import Pages from './tabs/Pages';
import QRCodes from './tabs/QRCodes';
import Surveys from './tabs/Surveys';
import ContentNavigation from './ContentNavigation';
import Teams from './tabs/Teams';

const Dashboard = () => {
    const location = useLocation();
    const [type, setType] = useState(location?.state?.type ?? 'email');

    return (
        <>
            <ContentNavigation
                type={type}
                onSetType={setType}
            />
            <Paper sx={{ px: 1.5 }} square>
                {type === 'email' && <Emails />}
                {type === 'page' && <Pages />}
                {type === 'qrcode' && <QRCodes />}
                {type === 'survey' && <Surveys />}
            </Paper>
            {type === 'teams' && <Teams />}
        </>
    );
};

export default Dashboard;
